import axios from '../utils/axios'

/*
* 获取通知
* limig
* page
*/
export const getNotice = function (data: { limit: number; page: number }) {
    return axios.post('/notice/getNotice', data)
}

/*
* 新建通知
* title: 标题
* texts: 内容
*/
export const setNotice = function (data: { title: string; texts: string }) {
    return axios.post('/notice/setNotice', data)
}

/*
* 删除通知，只能删除自己发出的通知
* id: 通知id
*/
export const delNotice = function (data: { id: number }) {
    return axios.delete('/notice/delNotice', { data })
}

/*
* 获取通知详情
* id: 通知id
*/
export const getNoticeById = function (data: { id: number }) {
    return axios.post('/notice/getNoticeById', data)
}

/*
* 将通知状态变为已读
* id: 通知id
*/
export const setReadStatus = function (data: { id: number }) {
    return axios.post('/notice/setReadStatus', data)
}

/*
* 获取审批中 ”我提交的“ 列表
*/
export const getMessageReview = function(data: { limit: number; page: number; status?: number }) {
    return axios.get('/message/getMessageReview', { params: data })
}

/*
* 获取审批中 “我审批的” 列表
*/
 // 2022-6-30 将get请求改为post
export const getMessageReviewByUserId = function (
    data: {
        limit: number;
        page: number;
        status?: number;
    }) {
    return axios.post('/message/getMessageReviewByUserId', data)
}

/*
* 查看审批
*/
export const getMessageReviewById = function (id: number, types: string) {
    return axios.get('/message/getMessageReviewById', {params: {id, types}})
}

/*
* 审批 通过与否
* messageReviewId: 审批id
* status: 审批结果 （ 1：通过； 2： 驳回）
* opinion: 审批意见 （选填）
*/
export const setMessageReviewUserByMessageReviewId = function(data: {
    messageReviewId: number;
    status: number;
    opinion: string;
    addData?: { url: string; name: string; types?: string }[];
}) {
    return axios.post('/message/setMessageReviewUserByMessageReviewId', data)
}

/*
* 审批 转交
* @messageReviewId 审批id
* @opinion 转交理由
* @userId 转交人id
* */
export const updMessageReviewUserByMessageReviewId = function(data: {
    messageReviewId: number;
    opinion?: string;
    userId: string;
}) {
    return axios.post('/message/updMessageReviewUserByMessageReviewId', data)
}

/*
* 审批 加签
* @messageReviewId 审批id
* @opinion 加签理由
* @userId 加签人id
* */
export const addMessageReviewUserByMessageReviewId = function(data: {
    messageReviewId: number;
    opinion?: string;
    userId: string;
}) {
    return axios.post('/message/addMessageReviewUserByMessageReviewId', data)
}

/*
* 提醒列表
* title: 提醒主题
* name: 所属对象
* limit
* page
*/
// 提醒列表

export const getMessageRemind = function(data: { 
    name: string; 
    limit: number; 
    page: number; 
    title: string;
    content?: string;
    createdAt?: string; //提醒时间
 }) {
    return axios.post('/message/getMessageRemind', data)
}
// 提醒列表导出
export const messageRemindExportData = function(data: { name?: string; title?: string; content?: string }) {
    return axios.post('/message/messageRemindExportData', data)
}


/*
* 同意或拒绝收回线索
* id
* status: 1-同意，2-拒绝
*/
export const setMessageRemindById = function(data: { id: string; status: number }) {
    return axios.post('/message/setMessageRemindById', data)
}

/*
* 获取未读消息个数
*/
export const getMessageCount = function() {
    return axios.get('/message/getMessageCount')
}

/*
 审批批量通过
 messageReviewIdList 审批id
 status 1-通过，2-驳回
*/
export const setMessageReviewUserByMessageReviewIdList = function(data: { messageReviewIdList: number[]; status: number }) {
    return axios.post('/message/setMessageReviewUserByMessageReviewIdList', data)
}

export const getMessageReviewCcList = function(data: { status: number; page: number; limit: number }) {
    return axios.get('/message/getMessageReviewCcList', { params: data })
}
// 修改我审批标记颜色
export const setMessageReviewUserColorByMessageReviewId = function(data: { messageReviewId: number }) {
    return axios.post('/message/setMessageReviewUserColorByMessageReviewId', data)
}

// 消息提醒跳转  getMessageRemindById
export const getMessageRemindById = function(data: { id: number }) {
    return axios.get('/message/getMessageRemindById', { params: data })
}
